// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px);
  padding: 20px;
  /* background-color: #f8f9fa; */
}

.ai-welcome {
  max-width: 800px;
  margin: 40px auto;
  text-align: center;
  padding: 20px;
}

.ai-welcome h1 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 10px;
}

.ai-welcome h2 {
  font-size: 1.8rem;
  color: #444;
  margin-bottom: 15px;
}

.ai-welcome p {
  font-size: 1rem;
  color: #666;
  margin-bottom: 40px;
}

.prompts-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.prompt-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #eee;
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.prompt-card:hover {
  transform: translateY(-2px);
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #7367f0; */
}

.prompt-icon {
  /* background-color: #f0f0ff; */
  color: #7367f0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.prompt-content {
  text-align: left;
  flex: 1 1;
}

.prompt-content h3 {
  font-size: 1rem;
  color: #333;
  margin-bottom: 5px;
}

.prompt-content p {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

.chat-messages {
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px;
  /* background-color: white; */
  border-radius: 10px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  margin-bottom: 20px;
}

.message {
  display: flex;
  margin-bottom: 20px;
}

.user-message {
  justify-content: flex-end;
}

.ai-message {
  justify-content: flex-start;
}

.message-content {
  max-width: 70%;
  padding: 12px 16px;
  border-radius: 12px;
  position: relative;
}

.user-message .message-content {
  background-color: #7367f0;
  color: white;
  border-bottom-right-radius: 4px;
}

.ai-message .message-content {
  background-color: #f8f8f8;
  color: #6e6b7b;
  border-bottom-left-radius: 4px;
}

.error-message .message-content {
  background-color: #ffa1a1;
  color: white;
}

.message-text {
  margin-bottom: 4px;
  line-height: 1.4;
}

.message-timestamp {
  font-size: 0.75rem;
  opacity: 0.7;
  text-align: right;
}

.chat-input-container {
  display: flex;
  align-items: center;
  gap: 10px;
  /* padding: 15px; */
  background-color: white;
  border-radius: 50px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
  padding: 0 5px 0 5px;
}

.chat-input {
  flex-grow: 1;
  padding: 12px 20px;
  border: none;
  background: transparent;
  outline: none;
  font-size: 1rem;
}

.send-button {
  width: 40px;
  height: 40px;
  background-color: #7367f0;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  padding: 0 10px;
}

.send-button:hover {
  background-color: #5e50ee;
}

.send-button:disabled {
  background-color: #b3b3b3;
  cursor: not-allowed;
}

/* Typing indicator */
.typing-indicator {
  display: flex;
  gap: 4px;
  padding: 8px 12px;
}

.typing-indicator span {
  width: 8px;
  height: 8px;
  background-color: #6e6b7b;
  border-radius: 50%;
  animation: typing 1s infinite ease-in-out;
}

.typing-indicator span:nth-child(1) {
  animation-delay: 0.2s;
}

.typing-indicator span:nth-child(2) {
  animation-delay: 0.3s;
}

.typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/screens/ai/ai.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B;0BACwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".chat-container {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 60px);\n  padding: 20px;\n  /* background-color: #f8f9fa; */\n}\n\n.ai-welcome {\n  max-width: 800px;\n  margin: 40px auto;\n  text-align: center;\n  padding: 20px;\n}\n\n.ai-welcome h1 {\n  font-size: 2.5rem;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.ai-welcome h2 {\n  font-size: 1.8rem;\n  color: #444;\n  margin-bottom: 15px;\n}\n\n.ai-welcome p {\n  font-size: 1rem;\n  color: #666;\n  margin-bottom: 40px;\n}\n\n.prompts-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.prompt-card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid #eee;\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n}\n\n.prompt-card:hover {\n  transform: translateY(-2px);\n  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-color: #7367f0; */\n}\n\n.prompt-icon {\n  /* background-color: #f0f0ff; */\n  color: #7367f0;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n}\n\n.prompt-content {\n  text-align: left;\n  flex: 1;\n}\n\n.prompt-content h3 {\n  font-size: 1rem;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n.prompt-content p {\n  font-size: 0.9rem;\n  color: #666;\n  margin: 0;\n}\n\n.chat-messages {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 20px;\n  /* background-color: white; */\n  border-radius: 10px;\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */\n  margin-bottom: 20px;\n}\n\n.message {\n  display: flex;\n  margin-bottom: 20px;\n}\n\n.user-message {\n  justify-content: flex-end;\n}\n\n.ai-message {\n  justify-content: flex-start;\n}\n\n.message-content {\n  max-width: 70%;\n  padding: 12px 16px;\n  border-radius: 12px;\n  position: relative;\n}\n\n.user-message .message-content {\n  background-color: #7367f0;\n  color: white;\n  border-bottom-right-radius: 4px;\n}\n\n.ai-message .message-content {\n  background-color: #f8f8f8;\n  color: #6e6b7b;\n  border-bottom-left-radius: 4px;\n}\n\n.error-message .message-content {\n  background-color: #ffa1a1;\n  color: white;\n}\n\n.message-text {\n  margin-bottom: 4px;\n  line-height: 1.4;\n}\n\n.message-timestamp {\n  font-size: 0.75rem;\n  opacity: 0.7;\n  text-align: right;\n}\n\n.chat-input-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  /* padding: 15px; */\n  background-color: white;\n  border-radius: 50px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin: 0 auto;\n  max-width: 600px;\n  width: 100%;\n  padding: 0 5px 0 5px;\n}\n\n.chat-input {\n  flex-grow: 1;\n  padding: 12px 20px;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 1rem;\n}\n\n.send-button {\n  width: 40px;\n  height: 40px;\n  background-color: #7367f0;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n  padding: 0 10px;\n}\n\n.send-button:hover {\n  background-color: #5e50ee;\n}\n\n.send-button:disabled {\n  background-color: #b3b3b3;\n  cursor: not-allowed;\n}\n\n/* Typing indicator */\n.typing-indicator {\n  display: flex;\n  gap: 4px;\n  padding: 8px 12px;\n}\n\n.typing-indicator span {\n  width: 8px;\n  height: 8px;\n  background-color: #6e6b7b;\n  border-radius: 50%;\n  animation: typing 1s infinite ease-in-out;\n}\n\n.typing-indicator span:nth-child(1) {\n  animation-delay: 0.2s;\n}\n\n.typing-indicator span:nth-child(2) {\n  animation-delay: 0.3s;\n}\n\n.typing-indicator span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typing {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-5px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
